import { configureStore } from '@reduxjs/toolkit'
import bannerReducer from './banners'
import brandsSliceReducer from './brands'
import conditionsReducer from './conditions'
import itemReducer from './items'
import orderReducer from './orders'
import promotionReducer from './promotions'
import shoppingCartReducer from './shopping-cart'
import templateReducer from './template'
import tituloReducer from './titulos'
import userReducer from './users'

export default configureStore({
  reducer: {
    users: userReducer,
    template: templateReducer,
    items: itemReducer,
    promotions: promotionReducer,
    orders: orderReducer,
    titulos: tituloReducer,
    conditions: conditionsReducer,
    shoppingCart: shoppingCartReducer,
    brands: brandsSliceReducer,
    banners: bannerReducer
  }
})
